/*==========================
 angular-infinite-scroll

 改於angular-infinite-scroll，支援window或inner content scroll模式
 http://binarymuse.github.io/ngInfiniteScroll/demo_async.html

 作者 : Augus
 最後更新日期 : 2013 / 11 / 20
==========================*/


var mod;

mod = angular.module('infinite-scroll', []);

mod.directive('infiniteScroll', [
    '$rootScope', '$timeout',
    function($rootScope, $timeout) {
        return {
            link: function(scope, elem, attrs) {

                var checkWhenEnabled, handler, scrollDistance, scrollEnabled, innerMode, target, $window, $elem;

                $window = $(window);
                target = attrs.infiniteScrollTarget;

                if (!target) {
                    $elem = $(elem);
                } else {
                    $elem = $(target);
                }

                innerMode = attrs.infiniteScrollInner;
                scrollDistance = 100;

                if (attrs.infiniteScrollDistance != null) {

                    scope.$watch(attrs.infiniteScrollDistance, function(value) {
                        return scrollDistance = parseInt(value, 10);
                    });

                }

                scrollEnabled = true;
                checkWhenEnabled = false;

                if (attrs.infiniteScrollDisabled != null) {
                    scope.$watch(attrs.infiniteScrollDisabled, function(value) {
                        scrollEnabled = !value;
                        if (scrollEnabled && checkWhenEnabled) {
                            checkWhenEnabled = false;
                            return handler();
                        }
                    });
                }
                handler = function() {
                    requestAnimationFrame(function() {
                        var elementBottom, remaining, shouldScroll, windowBottom;
                        // detect element scroll
                        if (innerMode) {
                            shouldScroll = ($elem.scrollTop() + $elem.innerHeight()) > ($elem[0].scrollHeight - scrollDistance);
                        }
                        // detect window scroll
                        else {

                            windowBottom = $window.height() + $window.scrollTop();
                            if (!elem.data('offsetTop')) {
                                elem.data('offsetTop', elem.offset().top);
                            }
                            elementBottom = elem.data('offsetTop') + elem.height();
                            remaining = elementBottom - windowBottom;
                            shouldScroll = remaining <= ($window.height() - scrollDistance);

                        }

                        if (shouldScroll && scrollEnabled) {

                            if ($rootScope.$$phase) {
                                return scope.$eval(attrs.infiniteScroll);
                            } else {
                                return scope.$apply(attrs.infiniteScroll);
                            }

                        } else if (shouldScroll) {

                            return checkWhenEnabled = true;

                        }
                    })

                };

                throttleEventWithRAFEvent('scroll', 'optimizedScroll', elem[0]);

                scope.enableInfiniteScroll = function() {
                    if (innerMode) {
                        throttleEventWithRAFEvent
                        $elem.on('optimizedScroll', handler);
                    } else {
                        $window.on('optimizedScroll', handler);
                    }
                }

                scope.disableInfiniteScroll = function() {
                    if (innerMode) {
                        $elem.off('optimizedScroll', handler);
                    } else {
                        $window.off('optimizedScroll', handler);
                    }
                }

                scope.enableInfiniteScroll();

                // scope.$on('$destroy', function () {
                //     $elem.off('scroll', handler);
                //     return $window.off('scroll', handler);
                // });

                return $timeout((function() {
                    if (attrs.infiniteScrollImmediateCheck) {
                        if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
                            return handler();
                        }
                    } else {
                        return handler();
                    }
                }), 0);
            }
        };
    }
]);